{
  "schemaVersion": 1,
  "analyses": {
    "30d": {
      "eyebrow": "近 30 天 · 周度研究结论",
      "headline": "Token 用量继续扩张，价格上行未改变低覆盖下的金额回落。",
      "summary": "近 30 天 Token 较前一等长区间增长 37.5%，加权公开牌价上升 12.6%。仅 1.0% 的 Token 可定价，情景估算金额下降 15.8%。",
      "evidence": [
        "30 天累计约 682.93 万亿 Token，较前一等长区间增长 37.5%。",
        "加权公开零售价约 $0.33 / 百万 Token，较前一等长区间上升 12.6%。",
        "情景估算金额约 $231.33 万，下降 15.8%；可定价 Token 覆盖率为 1.0%。"
      ],
      "eventReading": "既有重大模型发布日期线在本区间内没有新标记；GPT-5.6 与 Grok 4.5 均发布于区间开始之前，只能作时间参照。",
      "caveat": "仅 1.0% 的 Token 能按公开牌价估算，价格与金额对覆盖模型及样本结构高度敏感；估算金额不是平台流水或真实收入。",
      "generatedAt": "2026-10-18T12:08:32.383Z"
    },
    "90d": {
      "eyebrow": "近 90 天 · 周度研究结论",
      "headline": "Token 用量接近前期三倍，情景估算金额仍回落。",
      "summary": "近 90 天 Token 较前一等长区间增长 197.7%，加权公开牌价下降 4.6%，可定价覆盖率仅 1.8%。样本支持用量扩张，但不支持收入推断。",
      "evidence": [
        "90 天累计约 1,464.97 万亿 Token，较前一等长区间增长 197.7%。",
        "加权公开零售价约 $0.31 / 百万 Token，较前一等长区间下降 4.6%。",
        "情景估算金额约 $796.00 万，下降 26.0%；可定价 Token 覆盖率为 1.8%。"
      ],
      "eventReading": "当前 90 天区间没有既有发布日期标记；GPT-5.6 与 Grok 4.5 均发布于区间开始之前，不能据此解释区间变化。",
      "caveat": "公开路由样本不代表全球全部需求，且仅 1.8% 的 Token 有可用牌价；金额只是公开牌价情景估算，不代表真实收入。",
      "generatedAt": "2026-10-18T12:08:32.383Z"
    },
    "1y": {
      "eyebrow": "近 1 年 · 周度研究结论",
      "headline": "一年样本约 2,249.24 万亿 Token，前置比较仍非完整同比。",
      "summary": "近一年 Token 较现有前置样本增长 2,157.9%，加权公开牌价下降 39.8%，情景估算金额上升 158.1%。2025-01-01 之前没有样本，前置区间短于一年。",
      "evidence": [
        "一年累计约 2,249.24 万亿 Token，与现有前置样本相比增长 2,157.9%。",
        "加权公开零售价约 $0.43 / 百万 Token，较现有前置样本下降 39.8%。",
        "情景估算金额约 $4,737.66 万，增长 158.1%；可定价 Token 覆盖率为 4.9%。"
      ],
      "eventReading": "Gemini 3、DeepSeek V3.2/V4、Gemini 3.5、GPT-5.6 与 Grok 4.5 等既有发布日期落在本区间，仅标记观察时点。",
      "caveat": "前置区间缺少 2025-01-01 之前的数据，不是完整等长基期；仅 4.9% 的 Token 可定价，估算金额不代表真实收入。",
      "generatedAt": "2026-10-18T12:08:32.383Z"
    },
    "all": {
      "eyebrow": "完整历史 · 周度研究结论",
      "headline": "完整公开样本累计约 2,348.86 万亿 Token。",
      "summary": "自 2025 年起的公开样本累计约 2,348.86 万亿 Token。发布日期、公开牌价与需求曲线可交叉观察，但 5.7% 的可定价覆盖率不足以外推收入。",
      "evidence": [
        "自 2025 年起累计约 2,348.86 万亿 Token，完整样本没有可用的前置等长基期。",
        "全样本加权公开零售价约 $0.49 / 百万 Token。",
        "情景估算金额约 $6,573.57 万，可定价 Token 覆盖率为 5.7%。"
      ],
      "eventReading": "既有重大事件线覆盖 Gemini 2.0、Llama 4、Qwen3、Claude 4、GPT-5、Gemini 3、DeepSeek V3.2/V4、Gemini 3.5 与 GPT-5.6 等发布时间。",
      "caveat": "完整历史不展示同比；事件共时不代表因果，公开路由样本不代表全球全部需求，情景估算金额也不代表平台或行业真实收入。",
      "generatedAt": "2026-10-18T12:08:32.383Z"
    }
  }
}
